<!--  -->
<template>
    <div class="bod">
    <Breadcrumb style="margin-top: 20px;margin-left: 163px;margin-bottom: 20px;color: rgb(110, 114, 117);">
        <BreadcrumbItem to="/">首页</BreadcrumbItem>
        <BreadcrumbItem to="/message">相关资讯</BreadcrumbItem>
        <BreadcrumbItem>详情</BreadcrumbItem>
    </Breadcrumb>
      <div class="flex">
        <div style="width: 828px;margin-bottom: 70px;" class="biaoti">
            广州火炬高新技术创业服务中心与广州开发区科技企业孵化器协会领导参观指导朝九晚四巾帼创客中心
        </div>
      </div>
      <div class="flex">
      <div class="xgleft3"></div>
        <div class="xgleft4">各界关怀</div>
        <div class="xgleft1">发布时间：&nbsp&nbsp2022.05.10</div>
      </div>
      <div class="flex">
        <div class="wenben1" style="margin-bottom: 0;">
            5月9日下午，广州火炬高新技术创业服务中心企业服务部杨乐怡、广州开发区科技企业孵化器协会秘书长王天宜、工作人员严雪婧前来朝九晚四巾帼创客中心走访参观。
        </div>
      </div>
      <div class="flex">
        <div class="page8tu1"></div>
      </div>
      <div class="flex">
        <div style="margin-bottom: 50px;" class="wenben2">        双方就如何更好地以服务中小型企业会员的机遇给育儿妈妈创造更多灵活就业爱心岗位来推动社会事业发展的主题进行深入的交流探讨。</div>
      </div>
      <div class="flex">
        <div class="page8tu2"></div>
      </div>
      <div class="flex">
        <div style="margin-left: 200px;height: 50px;" class="wenben3">                朝九晚四巾帼创客中心正式加入广州开发区科技企业孵化器协会，成为其会员后，将联手共建社会公益事业，为育儿妈妈提供更多灵活就业的朝九晚四爱心岗位，实现上班近，下班早，顾家赚钱兼顾好的美好生活目标。</div>
      </div>
      <div class="flex">
        <hr class="hr1"/>
      </div>
      <div style="margin-left: 163px;float: left;">
        <div class="next">上一篇</div>
        <div class="nextkuang">
          <div class="xgleft1">2022.05.16</div>
          <router-link to="/page7" class="text1">朝九晚四灵活用工进园区公益活动--走进莱迪创新科技园</router-link>
          <div class="xgleft3"></div>
          <div class="xgleft4">就业创业</div>
          <router-link to="/page7" class="text2">上周，朝九晚四巾帼创客中心为继续推动育儿妈妈灵活就业，充分发挥女性能顶“半边天”的重要作用，走进广州莱迪创新科技园区，与其负责人共同探讨园区内的朝九晚四灵活就业岗位开发主题......</router-link>
          <router-link to="/page7"><div class="text3">查看详情<img src="../../../assets/images/you.png"></div></router-link>
        </div>
      </div>
      <div class="clean"></div>
    </div>
  
  </template>
  
  <script>
  export default {
    data() {
      return {
  
      }
    },
    methods: {
  
    },
    created() {
  
    }
  }
  </script>
  
  <style lang="less" scoped>
  @import "./page.less";
  </style>
  